<template>
  <opportunity-header ref="header" :show-title="showTitle" :firm="currentFirm" :pages="pages" :page-sizes="pageSizes"
    :num-items="count" :loading="isLoading" @search="search" />
  <div class="table-responsive">
    <div class="custom-listing-opportunities" :style="listingHeight">
      <z-table v-model="records" class="table table-bordered table-striped" :is-single-row-detail="true"
        :is-header-fixed="isHeaderFixed" :sort-by="sortBy" :order-by="orderBy" :columns="tableColumnsName"
        :detail-column-class="detailColumnClass" :loading="isLoading" @sort="setOrder">
        <template #tbody="props">
          <!-- <th scope="row" class="custom-column-80 text-center">{{ props.row.opportunity }}</th> -->
          <td>
            {{ formatDate(props.row.createdOn) }}
          </td>
          <td class="custom-column-160 text-center" style="position: relative">
            <a v-if="props.row.isViewable" href="#" @click="viewInspection(props.row)">{{ props.row.adasInspection
            }}</a>
            <span v-else>{{ props.row.adasInspection }}</span>
            <div v-if="props.row.numNotes > 0" class="custom-notes-icon">
              <span>{{ props.row.numNotes }}</span>
              <i class="fas fa-sticky-note"></i>
            </div>
          </td>
          <td>{{ props.row.firmName }}</td>
          <td>{{ props.row.sourceFirmName }}</td>
          <!-- Issue 622: the ticket asks the grid to identify a PDF-sourced request. ADAS Map calls it
               "C (PDF)"; here it rides beside the status, which still says where the request has got to. -->
          <td :class="setStatusClass(props.row.statusName)">
            {{ props.row.statusName }}
            <span v-if="props.row.wasPdf" class="badge bg-secondary ms-1" title="Created from an uploaded PDF estimate">PDF</span>
            <span v-if="props.row.wasVin" class="badge bg-secondary ms-1" title="Created from a VIN only, with no estimate">VIN</span>
          </td>
          <td>{{ props.row.year }}</td>
          <td>{{ props.row.make }}</td>
          <td>{{ props.row.model }}</td>
          <td>{{ props.row.vin }}</td>
          <td v-if="isViewingCompleted">{{ formatDate(props.row.completed) }}</td>
          <td v-else>{{ formatScheduled(props.row) }}</td>
          <td class="custom-column-120 text-center">{{ props.row.numCalibration }}</td>
          <td class="text-right">{{ getAmount(props.row) }}</td>
          <td class="text-right">{{ formatNumber(props.row.revenueShareFee) }}</td>
        </template>
        <template #detail="props">
          <opportunity-detail :opportunity="props.row" />
        </template>
        <template #empty> Nothing found! </template>
      </z-table>
    </div>
  </div>
  <dialog-opportunity v-model="actionOpportunity" @closing="closeModal" @saved="savedOpportunity" />
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { opportunityStore } from '@/stores/opportunity'
import { lookupStore } from '@/stores/lookup'
import { dashboardStore } from '@/stores/dashboard'
import router from '@/router'
import globals from '@/plugins/globals'
import ZTable from '@/components/utilities/elements/Table.vue'
import OpportunityHeader from './OpportunityHeader.vue'
import DialogOpportunity from './forms/DialogOpportunity.vue'
import OpportunityDetail from './OpportunityDetail.vue'
export default {
  name: 'OpportunityListing',
  components: {
    ZTable,
    OpportunityHeader,
    DialogOpportunity,
    OpportunityDetail
  },
  props: {
    isHeaderFixed: {
      type: Boolean,
      default: false
    },
    listingHeight: String
  },
  data() {
    return {
      actionOpportunity: null,
      pageSizes: [
        { name: '10', value: 10 },
        { name: '25', value: 25 },
        { name: '50', value: 50 },
        { name: '100', value: 100 }
      ],
      detailColumnClass: 'custom-column-60',
      isLoadingOpportunity: false
    }
  },
  async mounted() {
    this.page = 1
    this.isLoadingOpportunity = false
    this.isAdd = false
    this.restoreListParams()
    this.setListParam({
      name: 'filter',
      value: null
    })
    this.resetOpportunity()
    await this.getLookups({
      keys: ['Status', 'Reason'],
      firm: 1,
      refresh: false
    })
    await this.search()
  },
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(lookupStore, { lookupLoading: 'loading' }),
    ...mapState(opportunityStore, ['loading', 'listParams', 'opportunities', 'opportunity']),
    page() {
      return this.listParams.page
    },
    count() {
      return this.opportunities.count
    },
    records() {
      let _items = []
      if (this.opportunities && this.opportunities.items) {
        _items = this.opportunities.items.map((item) => ({
          ...item,
          isViewable: true
        }))
      }
      return _items
    },
    tableColumnsName() {
      console.log('List Params', this.listParams)
      let columns = [
        { field: 'createdOn', label: 'Created', sortable: true, class: 'custom-column-120 text-center' },
        // {
        //   field: 'opportunity',
        //   label: '#',
        //   sortable: true,
        //   class: 'custom-column-80 text-center'
        // },
        { field: 'adasInspection', label: 'Inspection #', sortable: true, class: 'custom-column-160 text-center' },
        { field: 'firmName', label: 'Calibration Center', sortable: true },
        { field: 'sourceFirmName', label: 'Location', sortable: true },
        { field: 'status', label: 'Status', sortable: true },
        { field: 'year', label: 'Year', sortable: false },
        { field: 'make', label: 'Make', sortable: true },
        { field: 'model', label: 'Model', sortable: false },
        { field: 'vin', label: 'VIN', sortable: true }
      ]
      if (this.listParams.status === '4') {
        columns.push({ field: 'completed', label: 'Completed', sortable: true })
      } else {
        columns.push({ field: 'scheduled', label: 'Scheduled', sortable: true })
      }
      let columns2 = [
        { field: 'numCalibration', label: '# ADAS Services', sortable: false, class: 'custom-column-120  text-center' },
        { field: 'price', label: 'Amount $', sortable: false, class: 'text-right' },
        { field: 'revenueShareFee', label: 'Fee $', sortable: false, class: 'text-right' }
      ]
      columns = columns.concat(columns2)
      return columns
    },
    pages() {
      return Math.ceil(this.opportunities.count / this.listParams.pageSize)
    },
    sortBy() {
      return this.listParams.sortBy
    },
    orderBy() {
      return this.listParams.orderBy
    },
    isLoading() {
      let _is = false
      if (this.loading.opportunities) {
        _is = true
      }
      return _is
    },
    isViewingCompleted() {
      return this.listParams.status === '4'
    }
  },
  methods: {
    ...mapActions(lookupStore, ['getLookups', 'getTechnicians']),
    ...mapActions(opportunityStore, ['restoreListParams', 'setListParam', 'paginate', 'getOpportunity', 'getOpportunities', 'resetOpportunity']),
    ...mapActions(dashboardStore, ['setInsurer', 'setFirm', 'setRoute']),
    formatDate(date, type = 'datetime') {
      return globals.formatDate(date, type)
    },
    formatScheduled(row) {
      if (!row.scheduled) return ''
      const date = globals.formatDate(row.scheduled, 'date')
      return row.preferredTimeOfDay ? `${date} (${row.preferredTimeOfDay})` : date
    },
    formatNumber(value) {
      return globals.formatNumber(value)
    },
    closeModal() {
      this.actionOpportunity = null
    },
    async setOrder(column, sortBy) {
      this.page = 1
      this.setListParam({
        name: 'sortBy',
        value: sortBy
      })
      this.setListParam({
        name: 'orderBy',
        value: column.field
      })
      await this.search(this.page)
    },
    setStatusClass(status) {
      let _class = ''
      if (status === 'Pending' || status === 'Hold') {
        _class = 'statusPending'
      } else if (status === 'Submitted') {
        _class = 'statusSubmitted'
      } else if (status === 'Working' || status === 'Submitted OK') {
        _class = 'statusWorking'
      } else if (status === 'Cancelled' || status === 'Voided') {
        _class = 'statusCancelled'
      } else if (status === 'Assigned') {
        _class = 'statusAssigned'
      } else if (status === 'Paid') {
        _class = 'statusPaid'
      } else {
        _class = 'statusCompleted'
      }
      return _class
    },
    async search(page = 1) {
      // Load up the Opportunities
      try {
        this.page = page
        await this.getOpportunities({
          page: this.page,
          offset: (this.page - 1) * this.listParams.pageSize,
          sortBy: this.listParams.sortBy,
          orderBy: this.listParams.orderBy,
          pageSize: this.listParams.pageSize,
          searchTerm: this.listParams.searchTerm,
          filter: this.listParams.filter,
          status: this.listParams.status,
          firm: this.firm !== undefined && this.firm !== null ? this.firm.firm : this.profile.firm,
          userId: this.profile.user
        })
      } catch (e) {
        console.log('Error', e)
      }
    },
    getAmount(data) {
      let amount = 0.0
      if (parseFloat(data.price) === 0 && parseFloat(data.offerPrice) > 0) {
        amount = parseFloat(data.offerPrice)
      } else {
        amount = parseFloat(data.price)
      }
      return this.formatNumber(amount)
    },
    async viewInspection(data) {
      console.log('View Inspection', data)
      this.setFirm({
        firm: data.sourceFirm,
        name: data.sourceFirmName,
        source: data.source,
        inspections: 0,
        address: null,
        addressLines: null,
        servicesCompleted: 0,
        servicesRequired: 0
      })
      await this.getLookups({
        keys: ['Technician'],
        firm: data.firm,
        refresh: false
      })
      this.setRoute('opportunity')
      router.push(`/vehicle-details/${data.vin}/${data.adasInspection}/location/${data.opportunity}`)
    },
    savedOpportunity() {
      this.search()
    }
  }
}
</script>
<style lang="scss" scoped>
.loadingWrapper {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  z-index: 10;
}

.custom-listing-opportunities {
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  max-height: 650px;
  height: 100%;
}

.custom-header {
  position: sticky;
  top: 0;
}

.custom-loading-opportunity {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background: rgba(0, 0, 0, 0.3);

  .loading-spinner {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    text-align: center;
    font-weight: 700;
    padding: 10px;
    z-index: 12;
    background-color: white;
    height: 45px;
    width: 150px;
    border-radius: 5px;

    span {
      margin-left: 5px;
      background-color: #fff;
    }
  }
}

.custom-notes-icon {
  position: absolute;
  top: 0;
  right: 5px;
  color: #0d6efd;
  font-size: 0.8em;

  span {
    font-size: 11px;
    color: rgb(0, 0, 0);
    margin-right: 2px;
  }
}

.custom-circle {
  display: inline-flex;
  /* Aligns text inside the circle */
  justify-content: center;
  /* Centers text horizontally */
  align-items: center;
  /* Centers text vertically */
  background-color: red;
  /* Circle background color */
  color: white;
  /* Text color */
  width: 20px;
  /* Fixed width for the circle */
  height: 20px;
  /* Fixed height for the circle */
  border-radius: 50%;
  /* Makes it a circle */
  font-weight: bold;
  /* Makes the number bold */
}

.statusPending {
  font-weight: 500;
  color: red;
}

.statusSubmitted {
  font-weight: 500;
  color: blue;
}

.statusWorking {
  font-weight: 500;
  color: green;
}

.statusCompleted {
  font-weight: 500;
  color: black;
}

.statusCancelled {
  font-weight: 500;
  color: rgb(116, 0, 0);
}

.statusAssigned {
  font-weight: 500;
  color: rgb(0, 121, 190);
}

.statusPaid {
  font-weight: 600;
  color: green;
}
</style>
